import angular from 'angular';
import _ from 'lodash-es';
import $ from 'jquery';
import Utils from '~/scripts/services/utils';
import APIV5 from '~/models/api';
import Node from './node';
import Method from '~/scripts/services/model/method';
import Card from './card';
import { createComponentInstance } from '~/components/kform/components/kform-component-class';
import moment from 'moment/moment';
import FormSubmission from './form-submission';
import FileUpload from '~/scripts/services/model/file-upload';
import Defaults from '~/scripts/constants/defaults';
import Lock from '~/scripts/services/model/lock';
import PdfUtils from '~/components/pdf/pdf-utils';
import { ConfirmDeleteModal } from '~/utils/modals';
import Lang from '~/scripts/services/model/lang';

/* globals Knitiv */

/**
 * @typedef FormExtraParams
 * @property {import('angular').IFormController} [formAttribut]
 * @property {import('angular').IFormController} [formRepre]
 * @property {import('angular').IFormController} [formRights]
 * @property {any} [formScope]
 * @property {import('angular').IFormController} [formWF]
 * @property {import('@knitiv/api-client-javascript').KNode} [formKid]
 * @property {boolean} [default]
 * @property {boolean} [generic]
 * @property {boolean} [modified]
 * @property {import('@knitiv/api-client-javascript').KNode} [new_isa]
 */

/**
 * @typedef FormBtnRecord
 * @property {string} action
 * @property {string} color
 * @property {string} icon
 * @property {string} name
 */

/**
 * @class
 */
// @ts-ignore
export default class Form extends Node {
	#$filter;

	#$injector;

	/** @type {Knitiv.RootScope} */
	#$rootScope;

	#$timeout;

	#$translate;

	#FormService;

	#Notification;

	/** @type {any} */
	#oldData;

	/** @type {FileUpload[]} */
	#oldFiles;

	/** @type {string | undefined} */
	#oldName; // TODO unused?

	/** @type {any} */
	#promiseExecScript;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('@knitiv/api-client-javascript').FormGetForm
	 *   & FormExtraParams
	 *   & {
	 *     files: FileUpload[],
	 *     submission: Knitiv.FormSubmissionEntry
	 *   }
	 *   | undefined} form
	 */
	constructor($injector, form = undefined) {
		super($injector, form?.kid);

		/** @type {import('angular').IFilterService} AngularJS $filter Service */
		this.#$filter = $injector?.get('$filter');

		/** @type {import('angular').IFilterService} AngularJS $filter Service */
		this.#$filter = $injector?.get('$filter');

		/** @type {import('angular').auto.IInjectorService} */
		this.#$injector = $injector;

		/** @type {Knitiv.RootScope} */
		// @ts-ignore
		this.#$rootScope = $injector?.get('$rootScope');

		/** @type {import('angular').ITimeoutService} AngularJS $timeout Service */
		this.#$timeout = $injector?.get('$timeout');

		/** @type {import('angular').translate.ITranslateService} AngularJS $translate Service */
		this.#$translate = $injector?.get('$translate');

		/** @type {import('~/scripts/services/form.service').default} */
		this.#FormService = $injector?.get('FormService');

		/** @type {any} */
		this.#Notification = $injector?.get('Notification');

		/** @type {any} */
		this.#oldData = {};

		/** @type {FileUpload[]} */
		this.#oldFiles = [];

		/** @type {string | undefined} */
		this.#oldName = undefined;

		/** @type {any} */
		this.#promiseExecScript = undefined;

		this.attribut = form?.attribut ?? [];

		/**
		 * @type {FormBtnRecord} Form "save button" definition
		 */
		this.btn_record = Defaults.kform.btn_record.save;

		/** @type {any} Keys cache for JS conditionals scripts */
		this.cacheKeys = {};

		/** @type {boolean} */
		this.create = form?.create ?? false;

		/** @type {any[]} Components structure */
		this.components = form?.components ? form.components.map(settings => createComponentInstance(settings)) : [];

		/** @type {boolean} */
		this.default = form?.default ?? false;

		/** @type {string} Form display */
		this.display = form?.display ?? 'form';

		/** @type {any[]} Form events */
		this.events = [];

		/** @type {FileUpload[]} */
		this.files = form?.files
			? form.files.map(file => new FileUpload(this.#$injector, file, file.name))
			: [];

		/** @type {any} Flat components types */
		this.flatTypes = {};

		/** @type {import('angular').IFormController | undefined} */
		this.formAttribut = form?.formAttribut;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} Form KID (from form builder) */
		this.formKid = form?.formKid;

		/** @type {import('angular').IFormController | undefined} */
		this.formRepre = form?.formRepre;

		/** @type {import('angular').IFormController | undefined} */
		this.formRights = form?.formRights;

		/**
		 * @type {import('angular').IScope & {
		 *   kformForm?: import('angular').IFormController
		 * } | undefined} Scope instance
		 */
		this.formScope = form?.formScope;

		/** @type {import('angular').IFormController | undefined} Form validation for workflow tab */
		this.formWF = form?.formWF;

		/** @type {boolean} Generic form */
		this.generic = form?.generic ?? false;

		/** @type {{fromParent: boolean, toParent: boolean} | undefined} */
		this.hasParentRelation = form?.hasParentRelation ?? {
			fromParent: false,
			toParent: false,
		};

		/** @type {string} Internal identifier */
		this.id = form?.kid ? `KF${form.kid.split(';')[1]}` : '';

		this.isa = form?.isa ?? {
			objid:   'K_NODE;0',
			objname: undefined,
			kright:  undefined,
			lang:    new Lang(),
		};

		this.isfile = form?.isfile === 1 ?? false;

		/** @type {boolean} */
		this.isTerminal = true;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = form?.kid;

		this.kright = form?.kright;

		/** @type {any} Labelfs flat map */
		this.labels = {};

		/** @type {boolean} Is last form? */
		this.lastForm = form?.lastForm ?? false;

		/** @type {{key: any, path: any, type: any}[]} List of existing nodes to link (from ktable) */
		this.linkTo = [];

		/** @type {any} Flat components map */
		this.map = {};

		this.name = form?.name;

		this.method = (form?.method && (Array.isArray(form.method) ? [...form.method] : Object.values(form.method)).map(
			m => new Method(m),
		)) ?? [];

		/** @type {boolean} Is form modified? */
		this.modified = false;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.new_isa = null;

		/**
		 * Downloads the file from the current form and opens it using the Knitiv Agent
		 */
		this.openWithKnitivAgent = this.#$injector.get('Agent').openFile;

		/** @type {import('~/types/form').KFormParams} */
		this.params = {
			defaultTab:            null,
			displayTabAttribut:    null,
			displayTabFile:        null,
			displayTabForm:        null,
			displayTabFormToolbar: null,
			displayTabHisto:       null,
			displayTabAerow:       null,
			displayTabRepre:       null,
			displayTabRights:      null,
			displayTabWF:          null,
			editable:              null,
			editableTabAttribut:   null,
			editableTabFile:       null,
			editableTabForm:       null,
			editableTabRepre:      null,
			editableTabRights:     null,
			editableTabWF:         null,
			file:                  {
				upload: {
					blacklist: null,
					camera:    null,
					html:      null,
					local:     null,
					// @ts-ignore
					maxSize:   null,
					// @ts-ignore
					minSize:   null,
					tree:      null,
					whitelist: null,
				},
			},
			forceUploadFile:       null,
			knote:                 null,
			tree:                  null,
			...form?.params,
		};

		/**
		 * @type {import('@knitiv/api-client-javascript').FormGetInput['parent'] | undefined}
		 */
		this.parent = undefined;

		/** @type {any} Prefix */
		this.prefix = undefined;

		/** @type {boolean} */
		this.readOnly = form?.readOnly ?? true;

		/** @type {import('tabulator-tables').RowComponent | undefined} */
		this.row = undefined;

		/** @type {string} Form script */
		this.script = form?.script ?? '';

		/** @type {FormSubmission} */
		this.submission = new FormSubmission(form?.submission);
		this.repre = this.submission.data.KREPRE ?? [];

		/** @type {string} Default form tab */
		this.tab = 'form';

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.target = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.term = null;

		/** @type {Record<string,import('~/scripts/services/model/file-upload').default[]>} */
		this.uploadFiles = {};

		/** @type {boolean} Is form inserting or updating? (KFORMSet operation) */
		this.updating = false;

		this.viewer_mimetype = form?.viewer_mimetype;
		if (form) {
			this.updateMap(form?.submission?.data);
		}
	}

	/**
	 * @param {string | string[]} keys
	 * @param {any} trigger
	 * @param {(arg0: any) => any} callback
	 */
	addEvent(keys, trigger, callback) {
		// eslint-disable-next-line no-param-reassign
		keys = Array.isArray(keys) ? keys : [keys];
		const { id } = this;

		for (const key of keys) {
			const nbAttempts = 20;
			const map = this.map[key];
			let selector = `#${id} `;

			let type = map?.type;

			if (key === 'KREPRE') {
				type = 'repre';
			}

			if (type) {
				switch (type) {
				case 'datagrid': {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="form-group-${key}"]`
						: `#form-group-${key}`;
					break;
				}

				case 'kpath': {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="${key}"]`
						: `#${key}`;
					break;
				}

				case 'ktable': {
					selector += `#form-group-${key} ktable`;
					break;
				}

				case 'radio': {
					// eslint-disable-next-line no-case-declarations
					const parentSelector = map.parent
						? `${selector}#form-group-${map.parent} *[id^="${key}"]`
						: `${selector}#form-group-${key}`;

					selector += `${parentSelector} input[type=radio], ${selector}#form-group-${key} .radio-delete`;

					if (trigger === 'change') {
						// eslint-disable-next-line no-param-reassign
						trigger = 'click';
					}
					break;
				}

				case 'mf': {
					selector += map.parent
						? `#form-group-${map.parent} div[id^="${key}"]`
						: `#${key}`;
					break;
				}

				case 'smartfield': {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="${key}"] input.form-control`
						: `#${key} input.form-control`;
					break;
				}

				default: {
					selector += map.parent
						? `#form-group-${map.parent} *[id^="${key}"]`
						: `#${key}`;
				}
				}

				const backoff = (
					/** @type {number} */ retries,
					/** @type {Function} */ ifn,
				) => ifn().catch((/** @type {any} */ error) => {
					if (retries > 1) {
						return this.#$timeout(() => backoff(retries - 1, ifn), 500);
					}

					throw error;
				});

				backoff(nbAttempts, () => {
					const element = $(selector);
					if (element.length === 0) {
						return Promise.reject(new Error('not found'));
					}
					return Promise.resolve(element);
				})
					// eslint-disable-next-line no-loop-func
					.then((/** @type {any} */ element) => {
						const { events } = this;
						events.push({ trigger, element });
						// eslint-disable-next-line promise/no-callback-in-promise
						return element.bind(trigger, (
							/** @type {Event} */ event,
							// eslint-disable-next-line promise/no-callback-in-promise
						) => this.#$timeout(() => callback(event)));
					})
					.catch(() => {
						console.warn(`DOM Element not found for ${key}`, `\nselector is ${selector}`);
					});
			}
		}
	}

	/**
	 * Adds a file to the current form
	 *
	 * @param {File} file File instance
	 * @param {?string} id File id (for kds) - if supplied, then replace it
	 * @returns {Promise<FileUpload | undefined>}
	 */
	async addFile(file, id = null) {
		/** @type {FileUpload | undefined} */
		let fileUpload;
		if (
			file
			&& !this.readOnly
			&& this.params.displayTabForm
		) {
			let indexFile = -1;

			if (id === null) {
				fileUpload = new FileUpload(this.#$injector, file);
				if (this.#$rootScope.kds) {
					const User = this.#$injector.get('User');
					fileUpload.id = User.getRef();
					this.files.push(fileUpload);
					this.params.defaultTab = 'form';
					indexFile = this.files.length - 1;
				}
				else {
					// replace file
					this.files = [fileUpload];
				}
			}
			else {
				indexFile = this.files.findIndex(file => file.id === id);
				if (indexFile >= 0) {
					fileUpload = this.files[indexFile];
					// replace file
					fileUpload.kid = null;
					fileUpload.url = null;
					fileUpload.file = file;
					fileUpload.name = file.name;
					fileUpload.uploaded = false;
				}
			}

			this.formScope?.kformForm?.$setDirty(); // TODO à vérifier
			this.isfile = false;
			this.viewer_engine = null;
			this.viewer_mimetype = file.type;

			if (fileUpload) {
				if (!this.getName()) {
					this.setName(fileUpload.name);
					this.submission.data.KREPRE = [...this.repre];
				}

				Object.entries(Defaults.viewerEnginesMimetypes)
					.some(([engine, mimetypeRegexp]) => {
						if (mimetypeRegexp.test(file.type)) {
							this.viewer_engine = engine;
							return true;
						}
						return false;
					});

				if (this.viewer_engine === 'pdf' && this.isa) {
					const fields = await APIV5.instance.docExtractFieldsGet({
						class_kid:     this.isa.objid,
						file_mimetype: file.type,
						file_name:     file.name,
						file_size:     file.size,
					}, { id: 'kform.add-file' });
					if (fields && Array.isArray(fields.value?.elts) && fields.value?.elts.length > 0) {
						const options = {
							search:   fields.value.elts,
							filename: file.name,
						};
						const pdfUtils = new PdfUtils(this.#$injector);
						const propositions = await pdfUtils.extractText(await file.arrayBuffer(), options);
						if (propositions?.length > 0) {
							this.fillSubmission(propositions.filter((/** @type {any} */ proposition) => proposition.enabled));
						}
					}
				}

				if (this.viewer_engine) {
					this.isfile = true;
				}

				if (this.viewer_engine && [
					'pdf',
					'video',
				].includes(this.viewer_engine)) {
					this.#$timeout(() => {
						if (fileUpload) {
							const $sce = this.#$injector.get('$sce');
							fileUpload.url
								= $sce.trustAsResourceUrl(URL.createObjectURL(new Blob([file], { type: file.type })));
							fileUpload.loaded = file.size;
						}
					});
				}
				else if (this.viewer_engine === 'image') {
					fileUpload.url = {
						rotate: 0,
						url:    URL.createObjectURL(new Blob([file], { type: file.type })),
						zoomed: false,
					};
					fileUpload.loaded = file.size;
				}
				else if (this.viewer_engine === 'json') {
					const fr = new FileReader();
					fr.addEventListener('load', () => {
						if (fileUpload) {
							try {
								fileUpload.url = JSON.parse(fr.result?.toString() ?? 'null');
								if (fr.result instanceof ArrayBuffer) {
									fileUpload.loaded = fr.result.byteLength;
								}
								else if (typeof fr.result === 'string') {
									fileUpload.loaded = fr.result.length;
								}
								else {
									fileUpload.loaded = 0;
								}
							}
							catch {
								this.#Notification.error({
									title:   this.#$translate.instant('error.title'),
									message: this.#$translate.instant('error.no-json-file'),
								});
							}
							this.#$rootScope.$apply();
						}
					});
					fr.readAsDataURL(file);
				}
				else if (this.viewer_engine && fileUpload && [
					'text',
					'html',
					'mail',
				].includes(this.viewer_engine)) {
					const fr = new FileReader();
					fr.addEventListener('load', () => {
						if (fileUpload && fr.result) {
							fileUpload.url = fr.result.toString();
							fileUpload.loaded = file.size;
							this.#$rootScope.$apply();
						}
					});
					fr.readAsDataURL(file);
				}
			}
		}
		return fileUpload;
	}

	/**
	 * @param {File[]} files
	 * @returns {Promise<*>}
	 */
	async addFiles(files) {
		return files.map(file => this.addFile(file));
	}

	backupFiles() {
		this.#oldFiles = [...this.files];
	}

	/**
	 * @param {string} key
	 * @returns {boolean}
	 */
	checkSubmit(key) {
		if (!(key in this.map)) {
			return false;
		}

		let returnCheckSubmit = this.map[key].properties.submit === true;

		if (returnCheckSubmit && this.map[key].fpath?.length > 0) {
			for (const fpathKey of this.map[key].fpath) {
				const component = this.getComponent(fpathKey);
				if (component?.nochildrensubmit) {
					returnCheckSubmit = false;
				}
			}
		}

		return returnCheckSubmit;
	}

	/**
	 * Removes a file
	 *
	 * @param {import('~/scripts/services/model/file-upload').default} file
	 * @returns {Promise<boolean>}
	 */
	async detachFile(file) {
		const modal = new ConfirmDeleteModal(this.#$injector);
		const answer = await modal.open(file?.name || this.#$translate.instant('common.document'));

		if (answer && this.kid) {
			let result;

			if (this.#$rootScope.kds) {
				file.deleted = true;
				result = true;
				this.formScope?.kformForm?.$setDirty();
			}
			else {
				result = file.uploaded && await this.#FormService.detachFile(this.kid) || !file.uploaded;
			}

			if (result) {
				if (this.row) {
					await this.row.update({
						file:           0,
						thumb_icon:     undefined,
						thumb_mimetype: undefined,
						viewer_engine:  undefined,
					});
				}
				const indexFile = this.files.findIndex(f => f.id === file.id);
				if (indexFile >= 0 && !this.#$rootScope.kds) {
					this.files.splice(indexFile, 1);
					this.isfile = this.files.length > 0;
				}
				return true;
			}
		}
		return false;
	}

	/**
	 * @returns {Promise<boolean>}
	 */
	async edit() {
		if (!this.params.editable) {
			return false;
		}

		if (this.readOnly && this.checkDroit(Defaults.DROIT.MODIFY)) {
			// Backup current data
			this.#oldData = {
				form:      _.cloneDeep(this.submission.data),
				droit:     _.cloneDeep(this.droit),
				droitcust: _.cloneDeep(this.droitcust),
				droitdef:  _.cloneDeep(this.droitdef),
				workflow:  _.cloneDeep(this.workflow),
			};

			this.#oldName = this.name;

			if (
				this.lock.locked
				&& this.#$rootScope.context?.profil.kid === this.lock?.profil?.kid
			) {
				await this.edit();
				this.#$rootScope.$emit('Form.edit');
				return true;
			}

			try {
				const lock = await this.#FormService.lock(this);
				this.readOnly = false;
				this.#$rootScope.$emit('Form.edit');
				this.#$timeout(() => {
					this.lock = new Lock(lock.lock);
					if (this.row) {
						return this.row.update({
							lock: this.lock,
							edit: true,
						});
					}
				});
				return true;
			}
			catch (/** @type {any} */ error) {
				console.error(error);
			}
		}

		return false;
	}

	export() {
		const form = {
			components: this.components.map(component => component.export()),
			create:     this.create,
			display:    this.display,
			name:       this.getName(),
			params:     this.params,
			script:     this.script,
		};
		return angular.toJson(form);
	}

	/**
	 * @param {any} submission
	 * @param {boolean} [noUpload]
	 * @returns {Promise<*[]>}
	 */
	async exportSubmissionData(submission, noUpload = false) {
		const submissionData = [];
		for (const [key, component] of Object.entries(this.map)) {
			let parent;
			if (component.parent) {
				parent = this.getComponent(component.parent);
			}
			if (!parent || parent.type !== 'datagrid') {
				const data = submission.data[key] ?? [];

				if (key === 'KREPRE') {
					submissionData.push({
						key,
						properties: component.properties,
						type:       component.type,
						values:     data.map(
							(/** @type {import('~/scripts/services/model/repre').default} */ repre) => repre.export(),
						),
					});
				}
				else if (component.type && this.checkSubmit(key)) {
					submissionData.push({
						key,
						properties: component.properties,
						type:       component.type,
						values:     await Promise.all(data.map(async (/** @type {any} */ d) => {
							switch (this.map[key].type) {
							case 'datagrid': {
								return Object.entries(d)
									.filter(entry => entry[1] !== undefined)
									.map(([key, values]) => ({
										key,
										properties: this.map[key].properties,
										type:       this.map[key].type,
										values,
									}));
							}
							case 'datetime': {
								if (d.name instanceof Date && !this.map[key].enableTime) {
									return { name: `${moment(data).format('YYYY-MM-DD')}Z` };
								}
								return d.name === undefined ? null : d;
							}
							case 'fileUpload': {
								if (!noUpload) {
									await d.upload();
									await d.prepareFinish();
									return { name: d.uploadFileId };
								}
								return d;
							}
							case 'jsoneditor': {
								if (d.name) {
									return d;
								}
								return this.map[key].preferText ? { name: '' } : null;
							}
							case 'password': {
								return d.name?.trim() === '' ? null : d;
							}
							case 'smartfield': {
								return d.name?.trim() === '' ? null : d;
							}
							default: {
								return d;
							}
							}
						})),
					});
				}
			}
		}

		return submissionData;
	}

	/**
	 * @param {any} propositions
	 */
	fillSubmission(propositions) {
		for (const [key, component] of Object.entries(this.map)) {
			for (const proposition of propositions) {
				if (proposition.assignto.type === 'KREPRE') {
					this.setName(proposition.str);
					this.submission.data.KREPRE = [...this.repre];
				}
				else {
					// remove incoherent flow in index 0 of path
					if (proposition.assignto.path?.length > 0 && 'flow' in proposition.assignto.path[0]) {
						delete proposition.assignto.path[0].flow;
					}
					if (component.path?.length > 0 && 'flow' in component.path[0]) {
						delete component.path[0].flow;
					}
					if (component.path && _.isEqual(proposition.assignto.path, component.path)) {
						// convert string to double
						if (component.type_kid === 'K_NODE;DOUBLE') {
							proposition.str = proposition.str.replace(' ', '').replace(',', '.');
						}

						switch (component.type) {
						case 'currency': {
							this.submission.data[key] = [{
								name: Number.parseFloat(proposition.str.replace(' ', '').replace(',', '.')),
							}];
							break;
						}

						case 'date': {
							this.submission.data[key] = [{
								name: Utils.parseDate(proposition.str),
							}];
							break;
						}

						default: {
							this.submission.data[key] = [{
								name: proposition.str,
							}];
							break;
						}
						}
					}
				}
			}
		}
	}

	/**
	 * @param {any} newForm
	 */
	import(newForm) {
		_.extend(this, newForm);
	}

	/**
	 * @param {any} error
	 * @returns {boolean}
	 */
	filterError(error) {
		return !!error?.$name;
	}

	/**
	 * @param {any[]} components
	 * @param {string} key
	 * @param {any[]} path
	 * @param {Function} function_
	 * @returns {any}
	 */
	findComponent(components, key, path, function_) {
		if (!components || !function_ || typeof function_ !== 'function') {
			return;
		}

		if (!key) {
			// eslint-disable-next-line consistent-return
			return function_(components);
		}

		// eslint-disable-next-line no-param-reassign
		path = path || [];

		for (const [index, component] of components.entries()) {
			const newPath = [...path];
			newPath.push(index);
			if (component) {
				if (component.key === key) {
					function_(component, newPath);
				}
				else if ('columns' in component && Array.isArray(component.columns)) {
					newPath.push('columns');
					for (const [indexColumn, column] of component.columns.entries()) {
						const colPath = [...newPath];
						colPath.push(indexColumn, 'components');
						this.findComponent(column.components, key, colPath, function_);
					}
				}
				else if ('rows' in component && Array.isArray(component.rows)) {
					newPath.push('rows');
					for (const [indexRow, row] of component.rows.entries()) {
						const rowPath = [...newPath];
						rowPath.push(indexRow);
						for (const [indexColumn, column] of row.entries()) {
							const colPath = [...rowPath];
							colPath.push(indexColumn, 'components');
							this.findComponent(column.components, key, colPath, function_);
						}
					}
				}
				else if ('tabs' in component && Array.isArray(component.tabs)) {
					newPath.push('tabs');
					for (const [indexTab, tab] of component.tabs.entries()) {
						const colPath = [...newPath];
						colPath.push(indexTab, 'components');
						this.findComponent(tab.components, key, colPath, function_);
					}
				}
				else if ('components' in component && Array.isArray(component.components)) {
					newPath.push('components');
					this.findComponent(component.components, key, newPath, function_);
				}
			}
		}
	}

	/**
	 * @param {any} components
	 * @param {string} type
	 * @param {Function} function_
	 * @returns {any}
	 */
	findComponentByType(components, type, function_) {
		if (!components || !function_ || typeof function_ !== 'function') {
			return;
		}

		if (!type) {
			// eslint-disable-next-line consistent-return
			return function_(components);
		}

		for (const component of Object.values(components)) {
			if (component) {
				if ('columns' in component && Array.isArray(component.columns)) {
					for (const column of component.columns) {
						this.findComponentByType(column.components, type, function_);
					}
				}

				if ('rows' in component && Array.isArray(component.rows)) {
					for (const row of component.rows) {
						for (const column of row) {
							this.findComponentByType(column.components, type, function_);
						}
					}
				}

				if ('tabs' in component && Array.isArray(component.tabs)) {
					for (const tab of component.tabs) {
						this.findComponentByType(tab.components, type, function_);
					}
				}

				if ('components' in component && Array.isArray(component.components)) {
					this.findComponentByType(component.components, type, function_);
				}

				if (component.type === type) {
					function_(component);
				}
			}
		}
	}

	/**
	 * @param {boolean} flagCreate
	 */
	fixKtableOptionParentCreate(flagCreate) {
		this.findComponentByType(this.components, 'ktable', (/** @type {any} */ c) => {
			if (c.options.parent) {
				c.options.parent.create = flagCreate;
			}
		});
	}

	/**
	 * Get component by key
	 *
	 * @param {string} key Component key
	 * @returns {any} Form component
	 */
	getComponent(key) {
		/** @type {any[]} */
		const path = [];

		/**
		 * @type {{component: any}}
		 */
		const returnValue = {
			component: undefined,
		};

		this.findComponent(this.components, key, path, (/** @type {any} */ c) => {
			returnValue.component = c;
		});

		if (returnValue.component?.type === 'ktable') {
			const ctrlComponentKtable = angular.element(`.kform-component-${returnValue.component.key} ktable`);
			if (ctrlComponentKtable) {
				// @ts-ignore
				const ctrlKtable = ctrlComponentKtable.children()?.scope()?.$ctrl;
				if (ctrlKtable?.table) {
					returnValue.component.table = ctrlKtable.table;
					returnValue.component.exec = () => {
						this.#$rootScope.$broadcast(
							`ktable-refresh-${returnValue.component.options.parent.kid}-${returnValue.component.key}`,
							{ script: false },
						);
					};
				}
			}
		}

		return returnValue.component;
	}

	/**
	 * Get component path by key
	 *
	 * @param {string} key Component key
	 * @returns {any[]} Path
	 */
	getComponentPath(key) {
		/** @type {any[]} */
		const path = [];

		/** @type {{path: any[]}} */
		const returnValue = { path: [] };

		this.findComponent(this.components, key, path, (/** @type {any} */ c, /** @type {any[]} */ newPath) => {
			returnValue.path = newPath;
		});

		return returnValue.path;
	}

	/**
	 * @param {string} id
	 * @param {string} key
	 * @returns {string}
	 */
	getErrorDescription(id, key) {
		if (id === 'mincard') {
			const component = this.getComponent(key);
			if (component?.validate?.card) {
				return this.#$filter('sprintf')(this.#$translate.instant('error.kform.' + id), component.validate.card.from);
			}
		}
		return this.#$translate.instant('error.kform.' + id);
	}

	/**
	 * @returns {FileUpload | undefined}
	 */
	getFilesFromMF() {
		let file;
		/** @type {[import('@knitiv/api-client-javascript').KNode, any]} */
		// @ts-ignore
		const entries = Object.entries(this.submission.data);
		for (const [isa, values] of entries) {
			if (Array.isArray(values)) {
				for (const value of values) {
					if (typeof value === 'object' && 'storage' in value && value.storage === 'base64') {
						const array = value.url.split(',');
						const mime = array[0].match(/:(.*?);/)[1];
						const bstr = atob(array[1]);
						let n = bstr.length;
						const data = new Uint8Array(n);
						while (n--) {
							// eslint-disable-next-line unicorn/prefer-code-point
							data[n] = bstr.charCodeAt(n);
						}
						file = new FileUpload(this.#$injector, new window.File([data], value.name, { type: mime }));
						file.data = data;
						file.isa = isa;
					}
				}
			}
		}
		return file;
	}

	/**
	 * @param {any} error
	 * @returns {string} Error message
	 */
	getLabelFromError(error) {
		const r = /^([^-]+)-?(\d+)?$/.exec(error.$name);
		let label;
		let index;
		let key = error.$name;

		if (r && r[1]) {
			[
				,
				key,
				index,
			] = r;
		}

		let skey;
		[key, skey] = key.split(':');

		if (key in this.labels) {
			label = this.labels[key];

			switch (skey) {
			case 'wf': {
				label += ' / ' + this.#$translate.instant('object.workflow');
				break;
			}
			case 'wfstate': {
				label += ' / ' + this.#$translate.instant('object.workflow-initial-state');
				break;
			}
			case 'wfallocator': {
				label += ' / ' + this.#$translate.instant('object.workflow-allocator');
				break;
			}
			case 'wfcomment': {
				label += ' / ' + this.#$translate.instant('object.workflow-comment');
				break;
			}
			}

			if (index && Number.parseInt(index) > 0) {
				label += ` (${index + 1})`;
			}
		}
		else {
			// this is probably a datagrid so we have to find parent
			const path = _.dropRight(this.getComponentPath(key), 2);
			const parent = _.get(this.components, path);
			const component = this.getComponent(key);

			label = parent ? parent.label || parent.title : key;
			if (index && Number.parseInt(index) > 0) {
				label += ` (${index + 1})`;
			}
			if (component) {
				if (label) {
					label += ` / ${component.label}`;
				}
				else {
					({ label } = component);
				}
			}
		}

		return `${label} : `;
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {string} key
	 * @returns {string}
	 */
	getValue(key) {
		return key;
	}

	/**
	 * @param {string} key
	 */
	hideComponent(key) {
		const component = this.getComponent(key);
		component.hidden = true;
		component.nochildrensubmit = true;
	}

	/**
	 * @param {any} source
	 * @returns {Promise<void>}
	 */
	async kexecScript(source) {
		if (this.script) {
			this.getValue = key => (
				this.submission?.data
				&& key in this.submission.data
				&& this.submission.data[key]
			);

			try {
				this.#FormService.evaluate(this.script, {
					api:  APIV5.instance,
					data: this.submission.data,
					form: this,
				});
				this.loading = false;
			}
			catch (/** @type {any} */ error) {
				console.error(error, source);
				this.#Notification.error({
					title:   this.#$translate.instant('error.title'),
					message: this.#$translate.instant('error.script-exec'),
				});
				this.disabled = true;
				this.loading = false;
				// TODO: fix infinite loop!
				// this.cancel(true, null);
				await APIV5.instance.sysBackTrace({
					data: {
						command:        'FormService.evaluate',
						error:          error.toString(),
						form:           this.export(),
						submissionData: this.exportSubmissionData(this.submission),
					},
				}, {
					id: 'kform.kexec-script',
				});
			}
			this.#promiseExecScript = undefined;
		}
	}

	/**
	 * @param {any} source
	 */
	kexecScriptWrapper(source) {
		if (this.#promiseExecScript) {
			this.#$timeout.cancel(this.#promiseExecScript);
		}
		this.#promiseExecScript = this.#$timeout(() => this.kexecScript(source), 500);
	}

	/**
	 * @param {string} event
	 * @param {Function} callback
	 */
	on(event, callback) {
		// @ts-ignore
		this.#$rootScope.$on(`Form.${event}`, (/** @type {any} */ event_) => callback(event_));
	}

	recursiveDeleteNodes() {
		for (const form of this.nodes) {
			this.#$rootScope.$broadcast('Form.delete', form.kid);
			if (form instanceof Form) {
				form.recursiveDeleteNodes();
			}
		}
		this.nodes.length = 0;
	}

	refresh() {
		this.#$rootScope?.$broadcast('Form.refresh');
	}

	removeEvents() {
		for (const event of this.events) {
			event.element.unbind();
		}
	}

	/**
	 * Resets the current form
	 *
	 * @returns {Promise<boolean>} true if ok
	 */
	async reset() {
		let deleteCurrentForm = false;
		const returnValue = true;

		// on efface dans le formulaire parent la valeur qui vient d'être rajoutée
		// dans le traitement du formulaire courant.
		if (this.create && this.parent instanceof Form) {
			for (const [key, values] of Object.entries(this.parent.submission.data)) {
				let indexToDelete = -1;
				if (Array.isArray(values)) {
					for (const [k, value] of values.entries()) {
						if (typeof value === 'object' && value.kid === this.kid) {
							indexToDelete = k;
						}
					}
					if (indexToDelete >= 0) {
						this.parent.submission.data[key].splice(indexToDelete, 1);
					}
				}
			}
			deleteCurrentForm = true;
		}

		if (this.#oldData) {
			if (this.create) {
				deleteCurrentForm = true;
			}
			else {
				this.submission.data = this.#oldData.form;
				this.droit = this.#oldData.droit;
				this.droitcust = this.#oldData.droitcust;
				this.droitdef = this.#oldData.droitdef;
				this.workflow = this.#oldData.workflow;
				this.#$timeout(() => {
					this.#$rootScope.$apply();
				});

				if (this.script) {
					this.#$timeout(() => {
						this.kexecScriptWrapper({
							origin: 'kform',
							method: 'reset',
						}); // jshint ignore:line
					}, 500);
				}
			}
		}

		if (Array.isArray(this.#oldFiles) && this.files) {
			this.files = this.#oldFiles;
			for (const file of this.files) {
				if (file.file) {
					file.loaded = file.file.size;
				}
			}
		}

		if (this.kid && this.lock.locked) {
			await this.unlock();
		}

		if (!this.parent) {
			if (this.row) {
				await this.row.update({ edit: false });
			}
			this.recursiveDeleteNodes();
		}
		this.#$rootScope.$broadcast('ktable-refresh');

		this.#$timeout(() => {
			this.modified = false;
			this.formScope?.kformForm?.$setPristine();
			this.formScope?.kformForm?.$setUntouched();
		});

		if (deleteCurrentForm && this.isa?.objid) {
			this.#FormService.mfCacheDelete(this.isa.objid);
			// TODO à vérifier
			this.#$rootScope.$emit('Form.delete', this.kid);
		}

		return returnValue;
	}

	/**
	 * @param {import('angular').IScope} scope
	 */
	setScope(scope) {
		this.formScope = scope;
	}

	/**
	 * @param {string} source
	 * @param {string} destination
	 * @param {any[]} path
	 * @param {any} data
	 */
	async setValueFromPath(source, destination, path, data) {
		const result = new Set();
		if (Array.isArray(data[source]) && data[source].length > 0) {
			for (/** @type {any} */ const value of data[source]) {
				const pathInfo = await APIV5.instance.queryPathInfo({
					list: [
						{
							node_kid: value.kid,
							path,
						},
					],
				}, { id: 'script' });
				if (pathInfo?.result?.list[0].rows) {
					const rows = pathInfo?.result?.list[0].rows;
					if (rows.length > 0) {
						rows[0][0].map((/** @type {any} */ cell) => result.add(cell));
					}
				}
			}
			data[destination] = [...result];
		}
		else {
			data[destination] = undefined;
		}
		this.updateForm(this);
	}

	/**
	 * @param {string} key
	 */
	showComponent(key) {
		const component = this.getComponent(key);
		component.hidden = false;
		component.nochildrensubmit = false;
	}

	sign() {
		const $location = this.#$injector.get('$location');
		this.#$timeout(() => {
			$location
				.path(`/e-sign/${this.kid}`)
				.search({
					return: window.location.pathname + window.location.search,
				});
		});
	}

	/**
	 * Unlocks the form
	 */
	async unlock() {
		if (!this.create) {
			await this.#FormService.unlock(this);
			this.#$timeout(async () => {
				this.lock = new Lock();
				this.readOnly = true;

				if (this.row) {
					await this.row.update({
						lock: this.lock,
						edit: false,
					});
				}
				this.#$rootScope.$apply();
			});
		}
	}

	/**
	 * @param {string} key
	 * @param {any} newComponent
	 * @returns {boolean}
	 */
	updateComponent(key, newComponent) {
		let returnValue = false;
		const component = typeof key === 'object' ? key : this.getComponent(key);

		if (component) {
			returnValue = true;
			const oldComponent = { ...component };
			_.merge(component, newComponent);
			if ('kdata' in newComponent) {
				this.updateMap();
			}
			if (!_.isEqual(oldComponent, component)) {
				this.#$rootScope?.$emit('Form.updateComponent', component);
				this.updateForm(this);
			}
		}
		else {
			console.error('Form.updateComponent: component not found', key);
		}

		return returnValue;
	}

	/**
	 * @param {Form} form
	 */
	updateForm(form) {
		if (!this.updating) {
			this.updating = true;
			this.#$timeout(() => {
				this.#$rootScope?.$broadcast('Form.update', form);
				this.updating = false;
			}, 500);
		}
	}


	/**
	 * Generates the map of the form
	 *
	 * @param {any} data Data from submission
	 */
	// eslint-disable-next-line class-methods-use-this
	updateMap(data = undefined) {
		this.map = {};
		this.labels = {};
		this.flatTypes = {};

		// ==== temp fix!!! ====
		// ==== Conversion des valeurs du submission.data en tableau ====
		if (data) {
			// const newdata = {...data};
			for (const [k, d] of Object.entries(data)) {
				if (d !== undefined && !Array.isArray(d)) {
					data[k] = typeof d === 'object' && ['kid', 'c'].some(key => Object.keys(d).includes(key))
						? [d]
						: [{ name: d }];
				}
			}
		}
		// ====

		const genMapComponents = (
			/** @type {import('@knitiv/api-client-javascript').FormComponent[]} */ components,
			/** @type {any} */ type = undefined,
			/** @type {any} */ parent = undefined,
			/** @type {any[]} */ fpath = [],
		) => {
			if (components !== undefined) {
				for (const component of components) {
					if (component) {
					// if (component.key in this.map) {
					// 	throw 'key already exists: ' + component.key;
					// }
						if ('components' in component) {
							if (component.type === 'datagrid') {
								this.map[component.key] = {
									properties: { ...component.kdata },
									type:       component.type,
									components: component.components.map((
										/** @type {any} */ component2,
									) => component2.key),
								};
								if (data && component.key in data) {
									for (const [k, row] of data[component.key].entries()) {
										data[component.key][k] = Object.fromEntries(
											row.map((/** @type {{ key: any; values: any; }} */ data) => [
												data.key,
												data.values
											]),
										);
									}
								}
								this.labels[component.key] = component.label;
							}
							// this.map[component.key].fpath = fpath;
							if (component.components) {
								genMapComponents(component.components, component.type, component.key, [
									...fpath,
									component.key,
								]);
							}
						}
						else if (component.type === 'table' && 'rows' in component) {
							for (const row of component.rows) {
								for (const col of row) {
									if (col.components) {
										genMapComponents(col.components, component.type, component.key, [
											...fpath,
											component.key,
										]);
									}
								}
							}
						}
						else if (component.type === 'columns' && 'columns' in component) {
							for (const col of component.columns) {
								if (col.components) {
									genMapComponents(col.components, component.type, component.key, [
										...fpath,
										component.key,
									]);
								}
							}
						}
						else if (component.type === 'tabs' && 'tabs' in component) {
							for (const tab of component.tabs) {
								if (tab.components) {
									genMapComponents(tab.components, component.type, component.key, [
										...fpath,
										component.key,
									]);
								}
							}
						}
						else {
							if ('kdata' in component && component.key) {
								// ----  TEST -----
								// if (['K_NODE;DOC_053', 'K_NODE;DOC_056_1', 'K_NODE;DOC_056_2', 'K_NODE;DOC_056_3']
								//     .indexOf(component.kdata.kid) >= 0) {
								// 	component.kdata.uploadFile = true;
								// 	if (component.kdata.kid !== 'K_NODE;DOC_053') {
								// 		component.validate.card = '0-N';
								// 	}
								// }
								// ----------------
								this.map[component.key] = {
									properties: { ...component.kdata },
									label:      component.label,
									type:       component.type,
									fpath,
								};
								this.labels[component.key] = component.label;
								if ('values' in component) {
									this.map[component.key].values = component.values;
								}
								if (data && !(component.key in data) && !component.defaultValue && type !== 'datagrid') {
									data[component.key] = [];
								}
								if (component.type === 'datetime') {
									this.map[component.key].enableTime = !!component.enableTime;
								}
								if (component.type === 'jsoneditor') {
									this.map[component.key].preferText = component.preferText;
								}
								if (data && component.type === 'radio' && component.key in data) {
									// ==== fix data ====
									data[component.key] = data[component.key].map((/** @type {any} */ d) => ({ kid: d.kid ?? d.name }));
									// ====
								}
								this.map[component.key].parent = parent;
							}

							if ('type' in component) {
								this.flatTypes[component.key] = component.type;
							}

							// ==== rétro-compatibilité ====
							if (component.validate && 'required' in component.validate) {
								component.validate.card = new Card(
									component.validate.required === true ? 1 : 0,
									component.multiple === true ? 'N' : 1,
								)
								delete component.validate.required;
								this.#$timeout(() => {
									this.#$rootScope.$emit('FormBuilder.update');
								});
							}
							if ('multiple' in component) {
								delete component.multiple;
								this.#$timeout(() => {
									this.#$rootScope.$emit('FormBuilder.update');
								});
							}
							// ====

							if (typeof component.validate?.card === 'string') {
								component.validate.card = new Card(component.validate.card);
							}
						}
					}
				}
			}
		};

		genMapComponents(this.components);
	}

	/**
	 * @returns {Promise<boolean>}
	 */
	async upload() {
		if (this.files.length > 0 && this.params.editableTabFile) {
			this.submission.files = [];
			for (const file of this.files) {
				/** @type {any} */
				const f = {};
				if (file.uploaded) {
					if (file.deleted) {
						f.action = 'DEL';
						f.id = file.id;
					}
					else if (file.file instanceof File) {
						await file.upload();
						f.fileid = file.uploadFileId;
						f.action = 'MOD';
						f.id = file.id;
					}
					else {
						f.fileid = file.id;
						f.action = 'MOD';
					}
				}
				else {
					const uploaded = await file.upload();
					if (!uploaded) {
						throw new Error('File is not uploaded');
					}
					file.uploaded = uploaded;
					file.uploadInit = false;
					f.fileid = file.uploadFileId;
					f.action = 'ADD';
				}
				if ('tree_kid' in file.file) {
					f.tree_kid = file.file.tree_kid;
					f.relpath = file.file.relpath;
				}
				if (f.action) {
					this.submission.files.push(f);
				}
			}
		}
		return true;
	}

	/**
	 * @returns {string}
	 */
	uuid() {
		return Utils.guid();
	}
}
